import { Channel } from '@kaltura-ott/tvpil-shared';

export function isChannel(channel: unknown): channel is Channel {
  return typeof channel === 'object' && channel !== null && 'type' in channel && channel.type === 'linear';
}
